<template>
  <div class="conversations-overview">
    <div class="row re-col-gutter col-12">
      <template v-if="props.conversations.length === 0">
        <p class="row col-12">
          {{ $t('monolith.inbox.no_conversations') }}
        </p>
      </template>
      <template v-else>
        <div class="col-md-6 col-sm-12 row conversations-overview__list">
          <ul>
            <li
              v-for="item in props.conversations"
              :key="item.id"
              :class="selectedConversation === item.id ? 'conversations-overview__item--selected' : ''"
              class="conversations-overview__item"
              @click="selectConversation(item.id)"
            >
              {{ item.subject }}

              <span>
                {{ $format.datetimeLong(item.last_message_at) }}
              </span>
            </li>
          </ul>
        </div>
        <div
          :id="talkjs.CHATBOX_ID"
          class="col-md-6 col-sm-12 row conversations-overview__chatbox"
        />
      </template>
    </div>
  </div>
</template>

<script setup>
import { inject, onMounted, ref } from 'vue'

import { talkjsKey } from '@/keys'

const talkjs = inject(talkjsKey)

const selectedConversation = ref()

const props = defineProps({
  conversations: {
    type: Array,
    default: () => [],
  },
})

function selectConversation(conversationId) {
  selectedConversation.value = conversationId
  talkjs.selectConversationOverview(conversationId)
}

onMounted(() => {
  const _selectedId = props.conversations[0]?.id
  if (_selectedId) {
    selectConversation(props.conversations[0]?.id)
  }
})
</script>

<style lang="scss" scoped>
.conversations-overview {
  height: 100%;
  width: 100%;
  min-width: 50vw;

  &__list {
    ul {
      width: 100%;
      list-style-type: none;
      padding: 0;
      border: 1px solid var(--border);
      border-radius: 10px;
      margin: 0;
      overflow: hidden;
    }
  }

  &__item {
    cursor: pointer;
    border-bottom: 1px solid var(--border);
    padding: 16px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 500;

    &:not(.conversations-overview__item--selected):hover {
      background-color: var(--light);
    }

    &--selected {
      background-color: var(--q-primary);
      color: var(--light);
    }

    span {
      font-size: 0.8em;
      color: var(--text-secondary);
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  &__chatbox {
    height: 600px !important;
  }
}
</style>
